import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: 'dateFormat'
})
@Injectable({
    providedIn: 'root'
})
export class DateFormatPipe implements PipeTransform {
    private datePipe = new DatePipe('en-US');

    transform(value: string | number | Date | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
        if (value) {
            return this.datePipe.transform(value, format, timezone, locale) ?? 'N/A';
        }
        return null;
    }
}